import { HttpInterceptorFn } from "@angular/common/http";

declare const FEATURE_APP_BASE_URL: string | undefined;

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (typeof FEATURE_APP_BASE_URL !== "undefined" && FEATURE_APP_BASE_URL) {
    const newRequest = req.clone({
      url: `${FEATURE_APP_BASE_URL}${req.url}`
    });
    return next(newRequest);
  }
  return next(req);
};
